import { Component } from '@angular/core';

@Component({
  selector: 'll-exam-sections-cash',
  templateUrl: './ll-exam-sections-cash.component.html',
  styleUrl: './ll-exam-sections-cash.component.css'
})
export class LlExamSectionsCashComponent {

}
